(function () {
  function readFlag() {
    if (window.__IS_STICKY_SORT_FILTER === true) return 'B';
    if (window.__IS_STICKY_SORT_FILTER === false) return 'A';

    // QA override only — real traffic is decided by window.__IS_STICKY_SORT_FILTER above.
    const qp = new URLSearchParams(location.search).get('__sticky_sort_filter');
    if (qp === '1') return 'B';
    if (qp === '0') return 'A';

    return null;
  }

  function loadStylesheet(href) {
    if (!href || document.querySelector(`link[href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function mountDesktopSkeleton(variant) {
    const host = document.querySelector('collection-desktop-filters');
    const tpl = document.getElementById(variant === 'B' ? 'collection-desktop-skeletons-b' : 'collection-desktop-skeletons-a');
    if (!host || !tpl) return;
    host.replaceChildren(tpl.content.cloneNode(true));
  }

  function loadController(variant, mount) {
    const src = variant === 'B' ? mount?.dataset.assetControllerB : mount?.dataset.assetControllerA;
    if (!src) return;

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.head.appendChild(script);
  }

  function commit(variant) {
    const mount = document.getElementById('collection-filter-ab-mount');

    if (variant === 'B' && mount) {
      document.documentElement.setAttribute('data-filter-variant', 'b');
      loadStylesheet(mount.dataset.assetCssFilterNew);
      loadStylesheet(mount.dataset.assetCssBarNew);
      loadStylesheet(mount.dataset.assetCssOverridesNew);
    }

    mountDesktopSkeleton(variant);
    loadController(variant, mount);
  }

  function boot() {
    const flag = readFlag();
    if (flag !== null) {
      commit(flag);
      return;
    }

    let settled = false;
    const settle = (resolved) => {
      if (settled) return;
      settled = true;
      clearInterval(timer);
      document.removeEventListener('igStickyFilterSortReady', onReady);
      commit(resolved !== null ? resolved : 'A');
    };

    const onReady = () => settle(readFlag());
    document.addEventListener('igStickyFilterSortReady', onReady);

    let waited = 0;
    const timer = setInterval(() => {
      waited += 200;
      const resolved = readFlag();
      if (resolved !== null || waited >= 15000) {
        settle(resolved);
      }
    }, 200);
  }

  boot();
})();
